import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Doctor } from './';
import { BackPagination } from '../shared/components';

@Injectable({
    providedIn: 'root',
})
export class DoctorsService {
    url = `${environment.managerURL}/users`;

    constructor(private http: HttpClient) {}

    getAll(page:number,pageSize?:number) {
        const response =  this.http.get<BackPagination<Doctor>>(`${this.url}?page=${page}&pageSize=${pageSize || 10}`);
        return response
    }

    getById(id: string) {
        return this.http.get<Doctor>(`${this.url}/${id}`);
    }

    getByTerm(term: string,page:number,pageSize?:number) {
        return this.http.get<BackPagination<Doctor>>(
            `${this.url}?searchTerm=${term}&page=${page}&pageSize=${pageSize || 10}`
        );
    }

    create(doctor: Doctor) {
        return this.http.post<Doctor>(this.url, doctor);
    }

    update(doctor: Doctor) {
        return this.http.put<Doctor>(this.url, doctor);
    }

    changePassword(userId: string, password: string) {
        return this.http.put(`${this.url}/pass`, { userId, password });
    }

    delete(id: string) {
        return this.http.delete(`${this.url}/${id}`);
    }
}
